import { DayExperience } from "@/models/DayExperience";
import { DayExperienceFilter } from "@/models/DayExperienceFilter";
import dayExperienceService from "@/services/day-experience.service";
import { ref } from "vue";

const useDayExperienceQuery = () => {
  const data = ref<DayExperience[]>();
  const isLoading = ref(false);
  const filter = ref<DayExperienceFilter>();

  const setFilter = (f: DayExperienceFilter) => {
    filter.value = f;
    if (f.islandFilters.find((i) => i === "all-islands")) {
      filter.value.islandFilters = [];
    }
    getExperiences();
  };

  const getExperiences = () => {
    isLoading.value = true;

    return dayExperienceService
      .getExperiences(
        filter.value?.islandFilters.length
          ? filter.value?.islandFilters
          : undefined,
        filter.value?.categoryFilters.length
          ? filter.value?.categoryFilters
          : undefined,
        filter.value?.text ? filter.value?.text : undefined
      )
      .then((experiences) => {
        data.value = experiences;
      })
      .finally(() => {
        isLoading.value = false;
      });
  };

  getExperiences();

  return {
    data,
    isLoading,
    setFilter,
  };
};

export default useDayExperienceQuery;
